import gql from "graphql-tag";

export default gql`
  query myConversations {
    myConversations(first: 100) {
      nodes {
        id
        listingId
        buyerId
        sellerId
        createdAt
        updatedAt
        carsForSaleByListingId {
          id
          make
          model
          year
          trim
          identityDisplayTitle
          price
          imageLoc
        }
        userByBuyerId {
          id
          firstname
          lastname
          profilePictureUrl
        }
        userBySellerId {
          id
          firstname
          lastname
          profilePictureUrl
        }
        latestMessage {
          id
          content
          senderId
          readAt
          createdAt
        }
      }
    }
  }
`;
